<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>

        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <users-overview :tableData="users" />
            </div>
        </div>
    </div>
</template>

<script>
import { userMixin } from 'relapp-users';

import { UsersOverview } from 'relapp-users';

export default {
    components: {
        UsersOverview
    },
    metaInfo: {
        title: trans('page.users.title')
    },
    mixins: [userMixin]
};
</script>
